import { dateToString } from "../../common/date-functions";
import { Box } from "@mui/material";

const getDescription = (order) => {
  let toReturn = "";

  const items = order.lines?.items;

  if (items && items?.length > 0) {
    toReturn = items[0].catalogSlide?.content?.description;

    if (items?.length > 1) {
      toReturn = toReturn + `, + ${items?.length - 1} more`;
    }
  } else if (order.paymentStatus && order.fulfillmentStatus) {
    toReturn = `${order.paymentStatus} ${order.fulfillmentStatus} Order`;
  } else {
    toReturn = `Order Total: $${order.terms?.total}`
  }

  return toReturn;
};



const formatDescription = (description, maxLength) => {

  if (description?.length > maxLength)
    return description.slice(0, maxLength) + "...";

  return description;
};

const OrderSummaryCell = ({ order }) => {

  return (
    <Box
      data-test-id="name-cell-container"
      data-field="name-cell-container"
      gap={1}
      sx={{
        display: "inline-flex",
        justifyContent: "flex-start",
        lineHeight: "normal",
      }}
    >
      <Box>
        <img
          alt={`${order.type === "Order" ? "One-time order" : "Autorefill order"}`}
          src={
            order.type === "Order"
              ? `icons/order-icon-onetime.svg`
              : `icons/order-icon-autoship-v2.svg`
          }
          style={{ width: "20px", height: "20px", marginTop: "4px" }}
        />
      </Box>
      <Box className="flex-column" style={{ alignItems: "baseline", gap: "2px" }}>
        <div style={{ fontWeight: 600, fontSize: "calc(12px * var(--unicity-font-scale, 1))" }} data-test-id={`order-title-${order.id.unicity}`}>{formatDescription(getDescription(order), 23)}</div>
        <div style={{ overflow: "visible !important", fontSize: "calc(10px * var(--unicity-font-scale, 1))", opacity: order.fulfillmentStatus === "Cancelled" ? "1" : ".6", color: order.fulfillmentStatus === "Cancelled" ? "#D03C3C" : "inherit" }}>
          {
            order.dateCreated ?
              <div>
                {order.fulfillmentStatus === "Cancelled" &&
                  <span style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }} data-test-id={`order-status-${order.id.unicity}`}>{`${order.fulfillmentStatus} • `}</span>
                }
                <span style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }} data-test-id={`order-date-${order.id.unicity}`}>{`${dateToString(new Date(order.dateCreated))}`}</span>{` • `}
                <span style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }} data-test-id={`order-id-${order.id.unicity}`}>{`${order.id.unicity}`}</span>
              </div>
              :
              <span style={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }} data-test-id={`order-id-${order.id.unicity}`}>{`${order.id.unicity}`}</span>
          }
        </div>
      </Box>
    </Box>
  );
};

export { OrderSummaryCell };
